import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "space-y-3 p-3" }
const _hoisted_2 = { class: "flex flex-row w-full justify-between items-center" }
const _hoisted_3 = { class: "text-2xl font-extralight py-1 w-9/12" }
const _hoisted_4 = {
  key: 0,
  class: "text-sm font-bold px-3 py-2 rounded-full border-2 border-green-400 text-center text-green-500"
}
const _hoisted_5 = { class: "w-full py-2" }
const _hoisted_6 = {
  key: 0,
  class: ""
}
const _hoisted_7 = { class: "flex flex-row justify-end space-x-3 p-2" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-row justify-between items-center bg-primary-light rounded-2xl px-4 py-2"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "You're now editing this evaluation", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "w-full flex flex-col justify-between items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScoreBar = _resolveComponent("ScoreBar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CategoryAnswerArrayField = _resolveComponent("CategoryAnswerArrayField")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", null, [
          (_ctx.isAnswered)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Answered "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_ScoreBar, {
          excellent: _ctx.score?.strong || 0,
          good: _ctx.score?.moderate || 0,
          bad: _ctx.score?.not_a_fit || 0
        }, null, 8, ["excellent", "good", "bad"])
      ]),
      (_ctx.isAnswered && !_ctx.isEditing && _ctx.currentStage === 'Screening')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Button, {
                label: "Edit evaluation",
                variant: "",
                onOnClick: _ctx.editForm
              }, null, 8, ["onOnClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_ctx.isEditing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("form", {
        onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
        class: "w-full flex flex-col"
      }, [
        _createElementVNode("fieldset", { disabled: _ctx.isAnswered }, [
          _createVNode(_component_CategoryAnswerArrayField, {
            errors: _ctx.errors,
            isAnswered: _ctx.isAnswered
          }, null, 8, ["errors", "isAnswered"])
        ], 8, _hoisted_11)
      ], 32)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_Loader)
        ]))
      : _createCommentVNode("", true)
  ]))
}